import { appConfig } from '../../../../../../../config/customization';
import Device from '../../../../../../../constants/deviceSizes';

const container = {
  display: 'flex',
  flexDirection: 'column'
};

const header = {
  display: 'flex',
  alignItems: 'center',
  height: 60,
  padding: '0 40px',
  boxShadow: `0 -1px 0 0 ${appConfig.colors.activeRowColor}, 0 2px 4px 0 ${appConfig.colors.shadowGrayTable}`,
  [Device.mobile]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0 20px'
  }
};

export default {
  container,
  header,
  arrowDown: {
    transform: 'rotate(180deg)'
  },
  firstMobileRow: {
    width: '30%',
    minWidth: 300,
    display: 'flex',
    justifyContent: 'spaceBetween',
    alignItems: 'center',
    [Device.mobile]: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-start'
    }
  },
  secondMobileRow: {
    width: '70%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [Device.mobile]: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-start'
    }
  },
  bar: {
    [Device.mobile]: {
      display: 'none'
    }
  },
  tableIsOpen: {
    height: 300 - header.height,
    backgroundColor: appConfig.colors.activeRowColor,
    width: '100%',
    paddingBottom: '8px',
    transition: 'height 0.2s ease',
    boxShadow: `inset 0px 11px 8px -10px ${appConfig.colors.shadowGrayTable}, inset 0px -11px 8px -10px ${appConfig.colors.shadowGrayTable}`
  },
  tableIsClosed: {
    height: 0
  },
  accountInfo: {
    display: 'flex',
    flex: 2,
    alignItems: 'center'
  },
  nis: {
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    [Device.mobile]: {
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-start',
      marginLeft: 10
    }
  },
  amount: {
    display: 'flex',
    flex: 1
  },
  paymentLabel: {
    textAlign: 'left',
    width: 120
  },
  billStatus: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '20px 0px'
  },
  payButton: {
    padding: '5px 8px'
  },
  downloadButtonContainer: {
    margin: '20px 0px'
  },
  downloadButton: {
    height: 23,
    padding: '0px 8px',
    whiteSpace: 'nowrap'
  },
  oddRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    width: '100%',
    padding: '5px 6px'
  },
  gridStyle: {
    overflowY: 'scroll',
    overflowX: 'hidden'
  }
};
